/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Guides_Start_IntroInputs */

const en_gc_guides_start_intro = /** @type {(inputs: Gc_Guides_Start_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The easiest way to learn GridCraft is to make one small change in a workbook you understand. A familiar expense table lets you concentrate on the editor instead of guessing what the data means. This guide uses the official ArtCraft browser build hosted on this site.`)
};

const zh_gc_guides_start_intro = /** @type {(inputs: Gc_Guides_Start_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习 GridCraft 最简单的方法，是在一份自己熟悉的工作簿中进行小修改。熟悉的支出表能让你专注于编辑器，而不是猜测数据含义。本指南使用本站托管的 ArtCraft 官方网页版本。`)
};

/**
* | output |
* | --- |
* | "The easiest way to learn GridCraft is to make one small change in a workbook you understand. A familiar expense table lets you concentrate on the editor inst..." |
*
* @param {Gc_Guides_Start_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_guides_start_intro = /** @type {((inputs?: Gc_Guides_Start_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Guides_Start_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_guides_start_intro(inputs)
	return zh_gc_guides_start_intro(inputs)
});
export { gc_guides_start_intro as "gc.guides.start.intro" }